import React from 'react';
export const AddModelModal = ({
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-445">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-446">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4" data-id="element-447">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-448">Add New Model</h3>
          <button className="text-gray-400 hover:text-gray-500" onClick={onClose} data-id="element-449">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-450">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-451" />
            </svg>
          </button>
        </div>
        <div className="p-6" data-id="element-452">
          <div className="flex mb-4" data-id="element-453">
            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-454">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-455">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" data-id="element-456" />
              </svg>
            </div>
            <div className="bg-gray-100 p-3 rounded-lg max-w-xs" data-id="element-457">
              <p className="text-sm text-gray-800" data-id="element-458">
                Hi, I am the model agent. I can help you create or import new
                forecasting models. Would you like to create a new model or
                import an existing one?
              </p>
              <span className="text-xs text-gray-500 block mt-1" data-id="element-459">01:51 PM</span>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 p-4" data-id="element-460">
          <div className="relative" data-id="element-461">
            <input type="text" placeholder="Type your message here..." className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-full focus:ring-blue-500 focus:border-blue-500" data-id="element-462" />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-463">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-464">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" data-id="element-465" />
              </svg>
            </div>
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-466">
              <button className="text-blue-500 hover:text-blue-600" data-id="element-467">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-468">
                  <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" data-id="element-469" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};